import { useData } from "data/data-provider";
import React from "react";

function Banner() {
    const {ourVehicles} = useData()
  return (
    <div className="w-full">
      <div className=" mx-auto flex flex-col md:flex-row justify-between items-center gap-12 md:gap-0">
        {/* Stat 1 */}
        <div className="flex flex-col items-center ">
          <span className="text-5xl md:text-6xl font-bold text-primary-100">
            34K+
          </span>
          <span className="mt-4 text-lg text-[#888888] font-medium">
            Happy Clients
          </span>
        </div>
        {/* Stat 2 */}
        <div className="flex flex-col items-center ">
          <span className="text-5xl md:text-6xl font-bold text-primary-100">
            99%
          </span>
          <span className="mt-4 text-lg text-[#888888] font-medium">
            Accident-Free Rentals
          </span>
        </div>
        {/* Stat 3 */}
        <div className="flex flex-col items-center ">
          <span className="text-5xl md:text-6xl font-bold text-primary-100">
            {ourVehicles.length}
          </span>
          <span className="mt-4 text-lg text-[#888888] font-medium">
            Luxury Cars
          </span>
        </div>
        {/* Stat 4 */}
        <div className="flex flex-col items-center ">
          <span className="text-5xl md:text-6xl font-bold text-primary-100">
            100%
          </span>
          <span className="mt-4 text-lg text-[#888888] font-medium">
            Fully Insured Vehicles
          </span>
        </div>
      </div>
    </div>
  );
}

export default Banner;
